// utils/auth.js

export const getToken = () => {
    try {
      return localStorage.getItem('jwtToken');
    } catch {
      return null;
    }
  };
  
  export const getUser = () => {
    try {
      const user = localStorage.getItem('user');
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  };
  
  export const getUserName = () => {
    try {
      return localStorage.getItem('userId');
    } catch {
      return null;
    }
  };
  